import { shuttleRoutes } from './data'
import { DeparturePlace } from './types'

/**
 * Checks if the route with the specified departure point is a shuttle connection
 *
 * @param {DeparturePlace} departurePlace - id identyfying one of available departure places
 * @return {boolean} determined true/false value for described condition
 */
export const isRouteShuttle = (departurePlace?: DeparturePlace) =>
    !!departurePlace && shuttleRoutes.includes(departurePlace)
